import { CoordinatorService } from './coordinator.service';

export class UploadFile {
    uploadId: string;
    hash: string;
    timestamp: number;
    size = 0;

    private _inProgress: boolean = false;
    private _isWaiting: boolean = false;
    private _failureCounter = 0;
    private _maxFailureCounter = 5;

    private _dirpath: string;
    private _filename: string;

    private _isForce = false;

    constructor(
        private coords: CoordinatorService,
        {
            uploadId,
            dirpath,
            timestamp,
            hash,
            filename,
            isForce,
        }: {
            uploadId: string;
            dirpath: string;
            // fdirH: FileSystemDirectoryHandle,
            filename: string;
            timestamp: number;
            hash: string;
            isForce: boolean;
        },
    ) {
        this.uploadId = uploadId;
        this.timestamp = timestamp;
        this.hash = hash;
        this._dirpath = dirpath;
        this._filename = filename;
        this._isForce = !!isForce;
    }

    async _dirH() {
        return await this.coords.utils$.filehandleFromPath(this._dirpath);
    }

    get projectId() {
        return this.uploadId.substring(0, this.uploadId.indexOf('|'));
    }

    get filename() {
        return this.uploadId.substring(this.uploadId.lastIndexOf('|') + 1);
    }

    public get inProgress(): boolean {
        return this._inProgress || this._isWaiting;
    }

    get isFailureExceeded() {
        return this._failureCounter >= this._maxFailureCounter;
    }

    start() {
        this._startUpload();
    }

    beforeUnload() {
        this._isForce = true;
        this._startUpload();
    }

    async terminate() {
        if (this._inProgress) {
            console.log('TERMINATE INTERRUPTED - uploadInProgress', this.uploadId);
            return false;
        }
        await this.coords.upload$.removeUploadFile(this);
        try {
            const dH = await this._dirH();
            await dH.removeEntry(this._filename);
        } catch (e) {}
        return true;
    }

    private async _startUpload(): Promise<void> {
        const m = this.coords.project$.current?.team?.currentUser;
        if (!m) return;
        const cloudFile = m.getOrCreateCloudFile(this.filename);
        if (!cloudFile) return;
        const dH = await this._dirH();
        const fH = await dH.getFileHandle(this._filename);
        const file = await fH.getFile();
        this.size = file.size;
        if (!this._isForce) {
            if (cloudFile.getHash() === this.hash) return;
            let w = Math.floor(this.size / 1024);

            if (w > 10) {
                w = Math.floor(Math.log10(w)) * 5 - 1;
                this._isWaiting = true;
                await this.coords.utils$.wait(w);
                this._isWaiting = false;
                if (this._inProgress) return;
                if (!this.coords.upload$.isLatestUploadFile(this)) {
                    this.terminate();
                    return;
                }
            }
        }

        this._inProgress = true;

        try {
            const resp = await this.coords.firebase$.storage.uploadFile(
                cloudFile.remotePath,
                file,
            );

            if (!resp) {
                this._failureCounter++;
                if (!this.isFailureExceeded) return this._startUpload();
                throw new Error(`Upload Failed ${cloudFile.remotePath}`);
            }

            const fs = this.coords.firebase$.firestore;
            const resp2 = await fs.addDocument(
                'storage',
                cloudFile.remotePath,
                fs.addTimestampField({
                    hash: this.hash,
                    userId: m.id,
                    projectId: this.projectId,
                    remotePath: cloudFile.remotePath,
                    size: this.size,
                    _instId: this.coords.instanceId,
                }),
            );
            if (!resp2) {
                this._failureCounter++;
                if (!this.isFailureExceeded) return this._startUpload();
                throw new Error(`Upload FIRESTORE notify failed${cloudFile.remotePath}`);
            }

            cloudFile.setHash(this.hash);
            this._inProgress = false;

            console.log(
                'FILE UPLOADED',
                this.projectId,
                this.filename,
                this.coords.utils$.bytesToHumanReadable(this.size),
                this,
            );
            await this.terminate();
        } finally {
            this._inProgress = false;
            this.coords.display$.markForCheck();
        }
    }
}
